module.exports = __webpack_public_path__ + "img/purple-3-squiggly-solid.0981e8de.svg";